









































/* eslint-disable @typescript-eslint/no-explicit-any */
import Vue from 'vue';
import axios from '@/plugins/axios';
import CtrlNumTxt from '@/components/common/control/CtrlNumTxt.vue';
import CtrlSearchBtn from '@/components/common/control/CtrlSearchBtn.vue';
import ListShukasakiSoko from '@/components/common/search/ListShukasakiSoko.vue';
import { API_SEARCH_SHUKASAKI_SOKO } from '@/constants/api';
import { noDataError, clearNoDataError } from '@/utils/message';

export default Vue.extend<any, any, any, any>({
  name: 'CtrlShukasakiSoko',
  components: {
    CtrlNumTxt,
    CtrlSearchBtn,
    ListShukasakiSoko,
  },
  props: {
    callbackCancel: {
      type: Function,
    },
    callbackOk: {
      type: Function,
    },
    label: {
      type: String,
      default: '集荷先倉庫',
    },
    widthCd: {
      type: Number,
      default: 99, //32,
    },
    widthName: {
      type: Number,
      default: 255,
    },
    required: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    mukoUmuFlg: {
      type: Number,
    },
  },
  data: () => ({
    API_SEARCH_SHUKASAKI_SOKO,
    listShukasakiSokoShow: false,
    sokoCd: 0,
    sokoRyakuMei: '',
    shiiresakiRyakuMei: '',
    errors: {
      errorMessages: '',
    },
    mounted: false,
    isNoData: false,
  }),
  computed: {
    styleItemName() {
      return {
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        width: `${this.widthName}px`,
        color: 'rgba(0, 0, 0, 0.87)',
        cursor: 'default',
      };
    },
  },
  methods: {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    handleOk(item: any) {
      const { sokoCd, sokoRyakuMei, shiiresakiRyakuMei } = item;
      this.sokoCd = sokoCd;
      this.sokoRyakuMei = sokoRyakuMei;
      this.shiiresakiRyakuMei = shiiresakiRyakuMei;
      this.listShukasakiSokoShow = false;
      this.errors.errorMessages = '';
      this.callbackOk && this.callbackOk(item);
      this.isNoData = false;
    },
    handleCancel() {
      this.listShukasakiSokoShow = false;
      this.callbackCancel && this.callbackCancel();
    },
    handleChange(value: number) {
      if (!this.mounted) return;
      this.sokoCd = value;
      if (value) {
        this.getShukasakiSokoItem();
      } else {
        this.sokoRyakuMei = '';
        this.errors = clearNoDataError();
        // IDをクリアするとデータをリセットする
        this.callbackOk && this.callbackOk({ sokoCd: this.sokoCd });
      }
    },
    getShukasakiSokoItem() {
      axios
        .get(API_SEARCH_SHUKASAKI_SOKO, {
          params: { sokoCd: this.sokoCd, mukoUmuFlg: this.mukoUmuFlg },
        })
        .then((res) => {
          if (!res.data.responseData || res.data.responseData.length === 0) {
            this.sokoRyakuMei = '';
            this.isNoData = true;
            this.errors = noDataError();
            this.callbackOk && this.callbackOk({ sokoCd: this.sokoCd });
            return;
          }
          this.errors = clearNoDataError();
          const { sokoRyakuMei } = res.data.responseData[0];
          this.sokoRyakuMei = sokoRyakuMei;
          this.callbackOk && this.callbackOk(res.data.responseData[0]);
          this.isNoData = false;
        });
    },
  },
  watch: {
    // 呼び出し元の tag の 引数 [sokoCd] に bind している変数 を監視する
    // 変数が、input 以外の event で値変更された時に、その値を control に set
    '$attrs.sokoCd': {
      handler(newValue) {
        if(+newValue === +this.sokoCd) return;
        this.sokoCd = +newValue;
        if (newValue) {
          this.getShukasakiSokoItem();
        } else {
          this.sokoRyakuMei = '';
          this.errors = clearNoDataError();
        }
      },
      immediate: true,
    },
  },
  mounted() {
    this.mounted = true;
  },
});
